import React, { useMemo } from 'react';

import { useStyles } from '@wix/tpa-settings/react';

import { buildCoverImage } from './cover-image';
import { getRandomThemeColorParam } from './colors';

export function useRandomCoverImage() {
  const styles = useStyles();

  const [image, setImage] = React.useState<File>();
  const [isLoading, setIsLoading] = React.useState(true);

  const color = useMemo(() => styles.get(getRandomThemeColorParam()), []);

  React.useEffect(() => {
    setIsLoading(true);

    buildCoverImage(color.value)
      .then(setImage)
      .finally(() => setIsLoading(false));
  }, [color.value]);

  return {
    image,
    isLoading,
  };
}
